import React, { useEffect, useState } from "react"
import styles from "./styles.module.scss"
import { jd100, jd50, aqy, tx, walmart, grab } from "../../images"
import { StorageBar, Storage } from "../styled-components"

const PrizeList = (props) => {
  const data = [
    {
      id: "WBX-JDK100",
      imgSrc: jd100,
      title: "京东商城购物券100元",
      storage: 0,
      desc: "库存充足",
    },
    {
      id: "WBX-JDK50",
      imgSrc: jd50,
      title: "京东商城购物券50元",
      storage: 0,
      desc: "库存紧张",
    },
    {
      id: "WBX-WEM20",
      imgSrc: walmart,
      title: "20元沃尔玛购物券",
      storage: 0,
      desc: "库存充足",
    },
    {
      id: "WBX-AQYSP",
      imgSrc: aqy,
      title: "爱奇艺月卡",
      storage: 0,
      desc: "库存充足",
    },
    {
      id: "WBX-TXSP",
      imgSrc: tx,
      title: "腾讯视频月卡",
      storage: 0,
      desc: "已抢光",
    },
  ]

  const { grabPrize, prizeList } = props
  const [dataDepublicate, changeData] = useState(data)

  useEffect(() => {
    if (prizeList.length >= 0) {
      data.forEach((item) => {
        prizeList.forEach((prize) => {
          if (item.id === prize.giftCode) {
            item["storage"] = prize.restPercent
          }
        })
      })
      changeData(data)
    }
  }, [prizeList])

  const renderItem = (data) => (
    <div className={styles.item} key={data.id}>
      <div className={styles.contentWrap}>
        <div className={styles.prizeIcon}>
          <img src={data.imgSrc} alt={data.title} />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>{data.title}</div>
          <div className={styles.storageBar}>
            <StorageBar width={data.storage} />
          </div>
          <Storage storage={data.storage}>{getDesc(data.storage)}</Storage>
        </div>
        <div className={styles.grabIcon} onClick={() => grabPrize(data.id)}>
          <img src={grab} alt="grab" />
        </div>
      </div>
    </div>
  )

  const getDesc = (storage) => {
    if (storage === 0) {
      return "已抢光"
    } else if (storage >= 10) {
      return "库存充足"
    } else {
      return "库存紧张"
    }
  }

  return <div className={styles.list}>{dataDepublicate.map(renderItem)}</div>
}

export default PrizeList
